/*
 * Show the active vehicle filter as "Vehicle: 2020 Toyota Tacoma" instead of the raw EasySearch tag
 * ("Vehicle: 2020-toyota-tacoma-esi4339790"). The tag is year-make-model-esiNNNN, so the readable name is
 * built from the year and a small model table; it does not depend on EasySearch having finished loading.
 */
(function () {
  var TAG_RE = /(\d{4})-([a-z0-9-]+)-esi\d+/i;
  var MODELS = {
    'chevrolet-colorado': 'Chevrolet Colorado',
    'chevrolet-silverado-1500': 'Chevrolet Silverado 1500',
    'ford-bronco': 'Ford Bronco',
    'ford-f-150': 'Ford F-150',
    'gmc-canyon': 'GMC Canyon',
    'gmc-sierra-1500': 'GMC Sierra 1500',
    'jeep-gladiator': 'Jeep Gladiator',
    'jeep-grand-cherokee': 'Jeep Grand Cherokee',
    'jeep-wrangler': 'Jeep Wrangler',
    'ram-1500': 'Ram 1500',
    'toyota-4runner': 'Toyota 4Runner',
    'toyota-land-cruiser': 'Toyota Land Cruiser',
    'toyota-tacoma': 'Toyota Tacoma'
  };

  function readable(m) {
    var model = MODELS[m[2].toLowerCase()];
    return model ? m[1] + ' ' + model : null;
  }

  function fix() {
    var nodes = document.querySelectorAll('.active-facets__button-inner, .active-facets__button');
    for (var i = 0; i < nodes.length; i++) {
      var walker = document.createTreeWalker(nodes[i], NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var m = node.nodeValue.match(TAG_RE);
        var name = m && readable(m);
        if (name) node.nodeValue = node.nodeValue.replace(m[0], name);
      }
    }
  }

  function init() {
    fix();
    new MutationObserver(fix).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
